import {
  SurveyPanel as ReactSurveyPanel,
  SurveyElementBase,
  SurveyElementErrors,
} from 'survey-react-ui';

import { Form } from '../../Form';

export class SurveyPanel extends ReactSurveyPanel {
  protected renderDescription(): JSX.Element | null {
    if (!this.panelBase.description) return null;

    return SurveyElementBase.renderLocString(this.panelBase.locDescription);
  }

  protected renderElement(): JSX.Element {
    const errors = (
      <SurveyElementErrors
        element={this.panelBase}
        cssClasses={this.panelBase.cssClasses}
        creator={this.creator}
      />
    );

    const style = {
      paddingLeft: this.panel.innerPaddingLeft,
      display: this.panel.renderedIsExpanded ? undefined : 'none',
    };

    let content: JSX.Element | null = null;

    if (this.panel.renderedIsExpanded) {
      const rows: JSX.Element[] = this.renderRows(this.panelBase.cssClasses);
      const className: string = this.panelBase.cssClasses.panel.content;
      content = this.renderContent(style, rows, className);
    }

    return (
      <Form.Section description={this.panel.description}>
        {this.panel.showErrorsAbovePanel ? errors : null}
        {this.panel.showErrorsAbovePanel ? null : errors}
        {content}
      </Form.Section>
    );
  }
}
